<div class="patient-carer-toggle" role="tablist" aria-label="Switch between patient and carer daily summary">
    <button
        type="button"
        role="tab"
        class="patient-carer-toggle__option"
        [class.active]="active === 'patient'"
        [attr.aria-selected]="active === 'patient'"
        (click)="choose('patient')">
        Patient
    </button>
    <button
        type="button"
        role="tab"
        class="patient-carer-toggle__option"
        [class.active]="active === 'carer'"
        [attr.aria-selected]="active === 'carer'"
        (click)="choose('carer')">
        Carer
    </button>
</div>
